module.exports = __webpack_public_path__ + "static/img/adoption_movie_thum_03.7b7d1f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/adoption_movie_thum_03.jpg
// module id = YQVJ
// module chunks = 0